import { ResidentCarFormDto, type ResidentCarFormInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/resident-car-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';

/** Resident car request body */
export type ResidentCarPersonalAccountFormInterface = Omit<ResidentCarFormInterface, 'client'>;

/** Resident car request body - DTO schema */
export const ResidentCarPersonalAccountFormDto = SerdeDtoClass.omit(CctvDtoKeysEnum.RESIDENT_CAR_PERSONAL_ACCOUNT_FORM_DTO, ResidentCarFormDto, ['client']);
